export const LOCAL_ONLY_KEY = 'pwa-local-only';

export function setLocalOnly(flag = true) {
  try {
    if (flag) localStorage.setItem(LOCAL_ONLY_KEY, '1');
    else localStorage.removeItem(LOCAL_ONLY_KEY);
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent('pwa:local-only-changed', { detail: { localOnly: flag } }));
  } catch {}
}

export function isLocalOnly() {
  try {
    return localStorage.getItem(LOCAL_ONLY_KEY) === '1';
  } catch {
    return false;
  }
}
